export default {
  beforeMount(el: any, binding: any) {
    // 定义点击外部的事件处理函数
    el.clickOutsideEvent = (event: any) => {
      // 如果点击的目标不在元素内部，则调用绑定的回调函数
      if (!el.contains(event.target)) {
        binding.value(event); // 调用传入的回调函数
      }
    };
    // 添加全局点击事件监听
    document.addEventListener('click', el.clickOutsideEvent);
  },
  unmounted(el: any) {
    // 移除全局点击事件监听
    document.removeEventListener('click', el.clickOutsideEvent);
  },
};
